import React, { useEffect, useState } from "react";
import BienvenidoAdmin from "../../components/administracion/BienvenidoAdmin";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import TablaExcepcionAnticipo from "../../components/administracion/TablaExcepcionAnticipo";
import { getToken } from "../../utils/auth";


const MESES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const AdminExcepcionAnticipo = () => {
    const [meses, setMeses] = useState([]);
    const [mesSeleccionado, setMesSeleccionado] = useState("");
    const [data, setData] = useState([]);
    const [loadingMeses, setLoadingMeses] = useState(false);
    const [loadingTabla, setLoadingTabla] = useState(false);
    const [error, setError] = useState("");
    const [descargandoDia, setDescargandoDia] = useState(false);
    const [descargandoMes, setDescargandoMes] = useState(false);

    const token = getToken();

    const consultar = async (anio, mes) => {
        const hoy = new Date();
        const anioFinal = anio ?? hoy.getFullYear();
        const mesFinal = mes ?? (hoy.getMonth() + 1);

        setLoadingTabla(true);
        setError("");
        try {
            const res = await fetch(process.env.REACT_APP_API_EXCEPCION_CONSULTAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, Anio: anioFinal, Mes: mesFinal }),
            });
            if (!res.ok) throw new Error("Error al consultar");
            const json = await res.json();
            setData(json || []);
        } catch (err) {
            setError(err.message || "Error al consultar");
            setData([]);
        } finally {
            setLoadingTabla(false);
        }
    };

    const cargarMeses = async () => {
        setLoadingMeses(true);
        setError("");
        try {
            const res = await fetch(process.env.REACT_APP_API_EXCEPCION_MESES, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token }),
            });
            if (!res.ok) throw new Error("Error al cargar meses");
            const json = await res.json();

            const mapped = (json || []).map((m) => ({
                anio: m.Anio,
                mes: m.Mes,
                value: `${m.Anio}-${String(m.Mes).padStart(2, "0")}`,
                label: `${MESES[m.Mes - 1]} ${m.Anio}`,
            }));

            const hoy = new Date();
            const anioActual = hoy.getFullYear();
            const mesActual = hoy.getMonth() + 1;
            const valueActual = `${anioActual}-${String(mesActual).padStart(2, "0")}`;

            const existeActual = mapped.find((m) => m.value === valueActual);
            const listaFinal = existeActual
                ? mapped
                : [{ anio: anioActual, mes: mesActual, value: valueActual, label: `${MESES[mesActual - 1]} ${anioActual}` }, ...mapped];

            setMeses(listaFinal);
            setMesSeleccionado(valueActual);
        } catch (err) {
            setError(err.message || "Error al cargar meses");
            setMeses([]);
        } finally {
            setLoadingMeses(false);
        }
    };

    useEffect(() => {
        if (token) {
            consultar();
            cargarMeses();
        } else {
            setError("Token no encontrado");
        }
    }, []);

    const onBuscar = () => {
        if (!mesSeleccionado) return;
        const [anio, mes] = mesSeleccionado.split("-").map(Number);
        consultar(anio, mes);
    };

    const formatearFechaAPI = (fecha) => {
        const d = new Date(fecha);
        if (Number.isNaN(d.getTime())) return null;
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    };

    const descargarDia = async (fechaFila) => {
        const fecha = formatearFechaAPI(fechaFila);
        if (!fecha) return;

        setDescargandoDia(true);
        try {
            const res = await fetch(process.env.REACT_APP_API_EXCEPCION_EXCEL_DIA, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, Fecha: fecha }),
            });

            if (!res.ok) throw new Error("Error al descargar día");

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `excepcion_anticipo_dia_${fecha.replaceAll("/", "")}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (e) {
            setError(e.message || "Error al descargar día");
        } finally {
            setDescargandoDia(false);
        }
    };

    const descargarMes = async () => {
        setDescargandoMes(true);
        try {
            const [anio, mes] = mesSeleccionado
                ? mesSeleccionado.split("-").map(Number)
                : [new Date().getFullYear(), new Date().getMonth() + 1];

            const res = await fetch(process.env.REACT_APP_API_EXCEPCION_EXCEL_MES, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, Anio: anio, Mes: mes }),
            });

            if (!res.ok) throw new Error("Error al descargar mes");

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `excepcion_anticipo_mes_${anio}_${String(mes).padStart(2, "0")}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (e) {
            setError(e.message || "Error al descargar mes");
        } finally {
            setDescargandoMes(false);
        }
    };

    return (
        <div translate="no" className="d-flex flex-column min-vh-100">
            <div className="pt-5">
                <BienvenidoAdmin />
            </div>
            <div>
                <TituloPagina title="Excepción Anticipo" />
            </div>

            <div className="py-4 container">
                <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                    <select
                        className="lato-regular border-0 filtro-fecha-administracion container"
                        value={mesSeleccionado}
                        onChange={(e) => setMesSeleccionado(e.target.value)}
                        disabled={loadingMeses || meses.length === 0}
                    >
                        <option value="">Seleccionar mes</option>
                        {meses.map((m) => (
                            <option key={m.value} value={m.value}>
                                {m.label}
                            </option>
                        ))}
                    </select>

                    <button
                        className="btn btn-dark"
                        onClick={onBuscar}
                        disabled={!mesSeleccionado || loadingTabla}
                    >
                        Buscar
                    </button>

                    <button
                        className="btn btn-dark"
                        onClick={descargarMes}
                        disabled={descargandoMes}
                    >
                        {descargandoMes ? "Descargando..." : "Descargar mes"}
                    </button>
                </div>

                <TablaExcepcionAnticipo
                    data={data}
                    loading={loadingTabla}
                    error={error}
                    onDescargarDia={descargarDia}
                    descargandoDia={descargandoDia}
                />
            </div>

            <div className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default AdminExcepcionAnticipo;
